import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Calendar } from 'primereact/calendar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePrecisionPulseReport } from '../../../Hooks/Features/Overview/usePrecisionPulseReport';
import { SkeletonDataTable } from '../../Loader/Loader';
import { useCommon } from '../../../Hooks/Common/useCommon';


const PrecisionPulseReport = () => {
  const { monthYear, setMonthYear, data, renderDropdown, renderInputNumber, renderTextarea, changeMonth, handleSubmit, loader, navigate, spin, tagRef } = usePrecisionPulseReport();
  const { checkPermission } = useCommon();

  return (
    <div className="mt-2" ref={() => checkPermission("teamlist", tagRef)}>
      <div ref={tagRef} id='{"tabname": "teamlist", "data": "team_list_precision_btn"}'>
        <div className="d-flex justify-content-between align-items-center gap-3">
          <div className='d-flex gap-4'>
            <h5> Precision Pulse Report</h5>
            <div className='d-flex justify-content-center align-items-center w30'>
              <FontAwesomeIcon
                icon="fa-solid fa-backward-step"
                onClick={() => changeMonth(-1)}
                style={{ cursor: "pointer", alignSelf: "start", marginTop: "7px" }}
              />
              <Calendar
                value={monthYear}
                onChange={(e) => setMonthYear(e.value)}
                view="month"
                dateFormat="mm/yy"
                style={{ alignSelf: "start" }}
              />
              <FontAwesomeIcon
                icon="fa-solid fa-forward-step"
                onClick={() => changeMonth(1)}
                style={{ cursor: "pointer", alignSelf: "start", marginTop: "7px" }}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end align-items-center mb-2'>
            {spin ? <button className="button btn-primary" style={{ width: "100px", height: "30px" }}>
              <div className="spinner-border" role="status" style={{ width: "20px", height: "20px" }}>
                <span className="sr-only"></span>
              </div>
            </button> :
              <button className="" onClick={handleSubmit} >Submit Report</button>}
            <button className='button btn-default' onClick={() => navigate(-1)}>
              <FontAwesomeIcon icon="fa-solid fa-arrow-left" /> Back
            </button>
          </div>
        </div>
        {
          loader ? <SkeletonDataTable nunumSkeletons={15} /> :
            <DataTable value={data} scrollable scrollHeight="100%" responsiveLayout="scroll" size="small"
            >
              <Column field="manager_name" header="Manager Name" headerClassName='text-center' />
              <Column field="user_display_name" header="Employee Name" headerClassName='text-center' />
              <Column body={(rowData) => renderInputNumber(rowData, 'bu_rank')} header="BU Rank" headerClassName='text-center' />
              <Column body={(rowData) => renderInputNumber(rowData, 'db_eff_rank')} header="DB Eff. Rank" headerClassName='text-center' />
              <Column body={(rowData) => renderInputNumber(rowData, 'tech_rank')} header="Tech Eff. Rank" headerClassName='text-center' />
              <Column body={(rowData) => renderInputNumber(rowData, 'time_efficiency_rank')} header="Time Eff. Rank" headerClassName='text-center' />
              <Column body={(rowData) => renderInputNumber(rowData, 'overall_standing_rank')} header="Overall Rank" headerClassName='text-center' />
              <Column body={renderDropdown} header="Involvement" headerClassName='text-center' />
              <Column body={(rowData) => renderTextarea(rowData, 'strength')} header="Strength" headerClassName='text-center' />
              <Column body={(rowData) => renderTextarea(rowData, 'weakness')} header="Weakness" headerClassName='text-center' />
              <Column body={(rowData) => renderTextarea(rowData, 'opportunity')} header="Opportunity" headerClassName='text-center' />
              <Column body={(rowData) => renderTextarea(rowData, 'threat')} header="Threat" headerClassName='text-center' />
            </DataTable>
        }
      </div>
    </div>
  );
};

export default PrecisionPulseReport;
